import React from 'react';

const WidgetPlanningActions = ({width = 20, height = 20, couleur = "#A8B0B3"}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
        <path d="M4 6.5H16V15.9993C16 17.3806 14.881 18.5 13.5 18.5H4V6.5Z" stroke={couleur} strokeWidth="2"
              strokeMiterlimit="10"></path>
        <path d="M12 18.5V14.5H16" stroke="#A8B0B3" strokeWidth="2" strokeMiterlimit="10"></path>
        <path d="M9.99947 8.92636L12.3764 3.74464" stroke={couleur} strokeWidth="1.5" strokeMiterlimit="10"></path>
        <path
            d="M13 4C13.8284 4 14.5 3.32843 14.5 2.5C14.5 1.67157 13.8284 1 13 1C12.1716 1 11.5 1.67157 11.5 2.5C11.5 3.32843 12.1716 4 13 4Z"
            stroke={couleur} strokeWidth="1.5" strokeMiterlimit="10"></path>
    </svg>
);

export default WidgetPlanningActions;
